// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 622) return "js/scanner.js";
	if (chunkId === 735) return "js/labels.js";
	// return url for filenames based on template
	return undefined;
};